module.exports = __webpack_public_path__ + "static/img/47.6aa1f19c.png";